export const typeToString = (v?:any): string | void => {
    try {
        return Object.prototype.toString.call(v).replace(/^\[object (\S+)\]$/, '$1');
    } catch (e) {
        console.error(e);
    }
}

export default typeToString;